import React from 'react';
import { DecorativeBorder, OliveBranch } from './DecorativeElements';
export function DolceVita() {
  return <section className="py-24 px-4 bg-paper-texture-dark relative overflow-hidden" data-id="element-194">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-195">
        <div className="absolute top-10 left-10 transform -rotate-45" data-id="element-196">
          <OliveBranch className="w-64 h-64 text-[var(--brown)]" data-id="element-197" />
        </div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-198">
        <div className="text-center mb-12" data-id="element-199">
          <h2 className="font-script text-5xl md:text-7xl text-[var(--sienna)] mb-6" data-id="element-200">
            Tra Ulivi e Luce
          </h2>
          <DecorativeBorder className="w-48 mx-auto text-[var(--brown)] opacity-50" data-id="element-201" />
        </div>

        <div className="prose prose-lg mx-auto text-center font-serif text-[var(--brown)]" data-id="element-202">
          <p className="text-xl md:text-2xl leading-relaxed mb-8" data-id="element-203">
            Here in Puglia, time moves differently. It flows like our olive
            oil—golden, rich, and unhurried.
          </p>

          <p className="mb-8" data-id="element-204">
            WACA is more than a villa; it's an invitation to pause. Surrounded
            by ancient olive groves and the distinctive conical roofs of Trulli
            houses, you'll find a peace that only the Italian countryside can
            offer.
          </p>

          <p className="mb-12" data-id="element-205">
            Spend your days exploring the white-washed towns of the Itria
            Valley, dipping into the crystal waters of the Adriatic, or simply
            reading a book under the shade of a centuries-old tree.
          </p>

          <div className="bg-[var(--paper)] p-8 md:p-12 rounded-sm shadow-sm border border-[var(--cream)] transform rotate-1 max-w-2xl mx-auto" data-id="element-206">
            <p className="font-script text-3xl text-[var(--sienna)] mb-4" data-id="element-207">
              You don’t just visit Puglia. For a while, you live it.
            </p>
            <p className="text-sm uppercase tracking-widest opacity-60" data-id="element-208">
              Live slowly, breathe deeply, feel at home.
            </p>
          </div>
        </div>
      </div>
    </section>;
}